import React from 'react';
import { Link } from 'react-router-dom';

function Dental() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Affordable Dental Packages Abroad: Comprehensive Dental Tourism Cost & Quality Guide
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          Basic dental care, complex structural reconstructions, and cosmetic smile designs have become prohibitively expensive across major Western countries. For thousands of international patients, exploring global dental destinations has become the definitive pathway to reclaiming oral health. 
          By cross-referencing clear analytical data on independent informational directories like <strong>Medical Trip World</strong>, travelers can research elite dental tourism packages—including implants, crowns, veneers, and full-mouth restorations—to save up to <strong>70%</strong> on clinical costs without sacrificing materials quality or procedural safety.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/compare-costs" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Comparative Dental Cost Estimates →
        </Link>
      </div>

      {/* SECTION 1: PROCEDURES OVERVIEW */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Advanced Restorative & Cosmetic Dentistry Options
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          When analyzing leading global dental hubs, patients focus primarily on three fundamental structural and cosmetic disciplines to complete their rehabilitation path:
        </p>
        <ul style={{ paddingLeft: '20px', color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <li>
            <strong>Premium Dental Implants (All-on-4 / All-on-6):</strong> Permanent titanium or zirconium post placements designed to replace missing root structures, providing a rock-solid structural baseline for complete fixed bridges and full-mouth overdentures.
          </li>
          <li>
            <strong>Porcelain Crowns & Bridges:</strong> High-grade restorative caps matching natural tooth enamel coloration, utilized to protect structurally compromised teeth, reinforce bite alignments, and close aesthetic gaps seamlessly.
          </li>
          <li>
            <strong>Cosmetic Dentistry (Porcelain Veneers):</strong> Minimal-prep wafer-thin porcelain shells bonded meticulously to the frontal tooth profile to resolve deep interior discoloration, enamel chips, spacing misalignments, and contour variances.
          </li>
        </ul>
      </section>

      {/* SECTION 2: SEO COST MAGNET MATRIX - SAFELY WRAPPED FOR MOBILE */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Estimated Global Dental Cost Benchmarks
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Unregulated domestic dentistry pricing can render advanced procedures unattainable. The figures highlighted below represent estimated comparative cost points gathered from public dental health registries and international sector summaries:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(12px, 4vw, 20px)', margin: '25px 0', borderRadius: '4px', borderLeft: '4px solid #005ba1' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.2rem', marginBottom: '10px' }}>📊 Estimated Dental Tourism Cost Indexes (USD):</h3>
          
          {/* Scroll Protective Wrapper Box */}
          <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', margin: '15px 0 5px 0' }}>
            <table style={{ width: '100%', minWidth: '600px', borderCollapse: 'collapse', color: '#333', textAlign: 'left', fontSize: '0.9rem' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #ddd' }}>
                  <th style={{ padding: '10px 8px' }}>Procedure Classification</th>
                  <th style={{ padding: '10px 8px' }}>United States (US)</th>
                  <th style={{ padding: '10px 8px' }}>United Kingdom (UK)</th>
                  <th style={{ padding: '10px 8px', color: '#28a745' }}>Global Facilitation Range</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Single Dental Implant (Post + Abutment + Crown)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$4,000 - $5,500</td>
                  <td style={{ padding: '10px 8px' }}>$2,500 - $3,500</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$800 - $1,200</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>Porcelain Veneer (Per Tooth)</strong></td>
                  <td style={{ padding: '10px 8px' }}>$1,800 - $2,500</td>
                  <td style={{ padding: '10px 8px' }}>$1,100 - $1,600</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$350 - $500</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 8px' }}><strong>All-on-4 Full Arch Fixed Restoration</strong></td>
                  <td style={{ padding: '10px 8px' }}>$24,000 - $30,000</td>
                  <td style={{ padding: '10px 8px' }}>$14,000 - $18,000</td>
                  <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#28a745' }}>$5,000 - $7,000</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <p style={{ margin: '10px 0 0 0', fontSize: '0.8rem', color: '#666', lineHeight: '1.5' }}>
            <em>*Data Compliance Notice: These financial statistics serve informational purposes only. Final pricing quotes depend completely on individual clinical clinic selection, custom panoramic OPG or 3D Cone Beam CT scans, required bone grafting or sinus lifts, and exact implant brand specifications.</em>
          </p>
        </div>
      </section>

      {/* SECTION 3: PROTOCOLS & QUALITY EVALUATION - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #f4f8fb', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Verifying Clinical Metrics in Global Dental Facilities
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates strictly as an independent information venue and directory, we advise international travelers to self-verify chosen dental studios by checking these critical safety operational points:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>Sterilization & Autoclave Log Verification</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Verify that the dental clinic enforces strict Class-B autoclave instrument sterilization cycles and complies meticulously with global monitoring criteria to ensure optimal infection control.
            </p>
          </div>
          <div style={{ padding: '15px', background: '#fafafa', borderRadius: '4px', border: '1px solid #eee' }}>
            <h4 style={{ margin: '0 0 8px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>CAD/CAM On-Site Digital Dental Labs</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Leading international centers utilize on-site Computer-Aided Design and Manufacturing (CAD/CAM) lab blocks to computer-mill premium crowns and veneers within 24 hours, heavily reducing travel stay durations.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e0e0e0', padding: 'clamp(15px, 4vw, 20px)', borderRadius: '4px' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem' }}>
          Frequently Asked Questions (FAQs) – Dental Tourism Analytics
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>How many visits are required to complete full dental implant treatments abroad?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Standard dental implant procedures generally require a two-stage approach. The primary trip requires a 4 to 7-day stay to securely place the titanium implant post. After a 3 to 6-month osseointegration healing window, a secondary trip of 5 to 10 days is scheduled to affix the permanent customized porcelain crown.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Are global dental implant brands traceable back home?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. Top international dental hubs deploy identical FDA-approved global implant systems (such as Nobel Biocare, Straumann, and MIS). Patients receive specialized component tracking passports containing structural product serial numbers for future local servicing checks.
          </p>
        </div>
        
        <div style={{ marginBottom: '5px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 5px 0', fontSize: '0.95rem' }}>Does Medical Trip World maintain commercial agreements with specific dental clinics?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions entirely as an independent informational reference platform and directory layout. We do not maintain official partnerships, commercial contracts, or active Memorandums of Understanding (MOUs) with any dental brand or surgical clinic. All financial quotes, clinical evaluation reviews, and therapeutic care obligations exist exclusively between the patient and their self-selected healthcare professional.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Begin Compiling Your Global Healthcare Research Diligently</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <style>{`
            @media (max-width: 550px) {
              .footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
            }
          `}</style>
          <Link to="/submit-query" className="footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            Submit Informational Request
          </Link>
          <Link to="/compare-costs" className="footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default Dental;